import { useMemo } from 'react'
import type { MarkingEditorState } from '../types'
import { hasStateChanges } from '../utils'

/**
 * Параметры для хука отслеживания изменений состояния редактора маркировки
 */
export interface UseMarkingChangesParams {
    /**
     * Текущее состояние редактора
     */
    currentState: MarkingEditorState
    /**
     * Начальное состояние редактора (для сравнения)
     */
    initialState: MarkingEditorState
}

/**
 * Хук для отслеживания изменений состояния редактора маркировки
 * Сравнивает текущее состояние с начальным и возвращает флаг наличия изменений
 */
export function useMarkingChanges(params: UseMarkingChangesParams): boolean {
    const { currentState, initialState } = params

    // Мемоизируем результат сравнения для оптимизации
    const hasChanges = useMemo(() => {
        return hasStateChanges(currentState, initialState)
    }, [currentState, initialState])

    return hasChanges
}
